import { useLocation } from 'react-router';
import { useEffect } from 'react';

import { ButtonLink as Link } from 'components/Button';
import { NavigationActionTypes, useNavigation } from 'contexts/NavigationContext';

import * as S from '../../styled';
import EmailForm from '../EmailForm/EmailForm';
import TokenPasswordForm from '../TokenPasswordForm/TokenPasswordForm';

import EmailFeedback from '../EmailFeedback/EmailFeedback';

const RecoverPasswordNavigation = () => {
  const location = useLocation();
  const { state: { step }, dispatch: setStep } = useNavigation(); // Pegando o estado e o dispatcher do contexto de navegação

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlToken = params.get('token');

    if (urlToken) {
      setStep({ type: NavigationActionTypes.SET_STEP , payload: 3 }); // Se o token estiver na URL, vai para o passo 3
    }
  }, [location.search, setStep]);

  return (
    <S.RecoverPasswordWrapper>
      <S.RecoverPasswordContainer>
        {/* Renderiza o passo de recuperação de senha com base no estado 'step' */}
        {step === 1 && <EmailForm />}  {/* Passo 1: Inserção de e-mail */}
        {step === 2 && <EmailFeedback />}  {/* Passo 2: Feedback - Email enviado */}
        {step === 3 && <TokenPasswordForm />}  {/* Passo 3: Inserir Token e nova senha */}

        <S.LoginLink>
          <Link to="/login" variant="link">Lembrei minha senha</Link>
        </S.LoginLink>
      </S.RecoverPasswordContainer>
    </S.RecoverPasswordWrapper>
  );
};


export default RecoverPasswordNavigation;
